export default "__VITE_ASSET__DqhKw04c__"